import { createContext, useContext } from 'react';

export interface CityContextType {
  citySelected: string | undefined;
  selectedCityLabel: string | undefined;
  setCitySelected: (
    citySelected: string | undefined,
    cityLabel: string | undefined,
  ) => void;
  category: string;
  queryParams: string;
}

const defaultValue: CityContextType = {
  citySelected: undefined,
  selectedCityLabel: undefined,
  setCitySelected: (_citySelected, _cityLabel) => {},
  category: 'Home',
  queryParams: '',
};

export const CityContext = createContext<CityContextType>(defaultValue);

export const useCitySelectedContext = (): CityContextType =>
  useContext(CityContext);
